<template>
  <div class="question-view" ref="questionView">
    <FixedFontSizeSelector class="fixedFontSizeSelector">
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`} ${!form.img_url && 'flex: 1;'}`">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>
      <div class="choice-list">
        <div :class="['single', its.check && 'single-select']" :data-id="its.id"
         v-for="(its, idx) in choice_option" :key="idx" @click="clickChoice(idx, its.id)">
          <span class="single-letter">{{ letter[idx] }}.</span>
          <span class="single-cte" v-if="its.type == '0'">
            <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="its.choice" :safe="false"/>
          </span>
          <img v-else class="single-img" :src="its.choice" alt="">
        </div>
      </div>
    </div>
    </FixedFontSizeSelector>
    <div class="quest-img" v-if="form.img_url" @click="$emit('urlToParent', form.img_url)">
      <img :src="form.img_url" :style="imgStyle" alt="">
    </div>

  </div>
</template>

<script>
import { isPC } from '@/utils/is-rules.js'
import FixedFontSizeSelector from '@/views/examination/components/dialog/FontSizeSelector'
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,
      letter,
      choice_option: [],
      imgStyle: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      // 记录题目及答案
      recordQuestion: null,
      // 记录答题次数
      limit: 0
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1 + this.choice_option.filter(its => its.type == '0' && its).length

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)
      this.limit = 0
      // 重置数据
      this.choice_option.filter((its) => its.check = false)

      // 去除选中样式
      let checks = document.querySelectorAll('.single-select')
      Array.from(checks).filter(its => its.classList.remove('single-select'))

      console.log(JSON.parse(JSON.stringify(this.choice_option)))
      this.recordQuestion = []
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answers = form.answers.map(its => its.choice_id),
      blocks = document.querySelectorAll('.choice-list .single')
      console.log(recordQuestion)
      if(recordQuestion == null) {
        return ;
      }
      this.limit = 1
      
      for(let i = 0; i < this.choice_option.length; i++) {
        let block = blocks[i],
        id = Number(block.dataset.id)
        block.setAttribute('class', 'single')
        if(recordQuestion.includes(id)) {
          // this.choice_option[i].check = true
          block.classList.add('single-select')

          if(this.mode == 'question') {
            continue ;
          }
          console.log(answers, id)
          if(answers.includes(id)) {
            block.classList.add('determine-success-br')
            console.log(block)
          } else if(block.classList.contains('single-select')){
            block.classList.add('determine-error-br')
          }
        }
      }
    },
    clickChoice(idx) {
      this.choice_option[idx].check = !this.choice_option[idx].check
      this.$emit('permissions', true)
      this.limit = 0

      this.recordQuestion = []
      this.answer_results.student_choices = []
      this.choice_option.map(its => {
        if(its.check) {
          this.limit = 1
          this.recordQuestion.push(Number(its.id))
          this.answer_results.student_choices.push({choice_id: Number(its.id), value: ''})
        }
      })

      let isEmpty = this.choice_option.some(its => its.check)

      if(!isEmpty) this.resetting()
    },
    lockPullDown() {
      const el = this.$refs.questionView;
      if (!el) return;

      let touchStartY = 0;

      // 记录起点
      el.addEventListener("touchstart", (e) => {
        touchStartY = e.touches[0].pageY;
      }, { passive: true });

      // 滑动时判断：只要是【向下拉】就拦截
      el.addEventListener("touchmove", (e) => {
        const moveY = e.touches[0].pageY;
        const isPullDown = moveY > touchStartY;

        // 只要是 下拉动作 → 直接禁止
        if (isPullDown) {
          e.preventDefault();
        }
      }, { passive: false });
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      // 记录题目及答案
      this.recordQuestion = null
      this.choice_option = []
      
      this.choice_option = this.form.choices.map(its => {
        let choice = its.value.substring(its.value.indexOf('.') + 1)
        if(choice) return { ...its, choice, check: false}
      }).filter(its => its)

      console.log(this.choice_option)
      setTimeout(() => this.showTrueFalse(), 1000)
    }
  },
  created() {
    if(isPC()) {
      this.imgStyle = {
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        margin: 'auto'
      }
    }
    this.initData()
    this.lockPullDown();
    // 根据 form.img_url 调整宽度
    if (!this.form.img_url) {
      document.documentElement.style.setProperty('--selector-width', '100%');
    } else {
      document.documentElement.style.setProperty('--selector-width', '50%');
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');
/* 默认样式 */
.fixedFontSizeSelector {
  width: var(--selector-width, 50%); /* 默认 50%，JS 可覆盖 */
}

/* 小屏手机（≤480px）时 */
@media (max-width: 480px) {
  .fixedFontSizeSelector {
    width: var(--selector-width, 100%); /* 默认 100%，JS 可覆盖 */
  }
}
.question-view {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;

  /* 核心：彻底禁止这个盒子里的下拉刷新 + 回弹 */
  overscroll-behavior: none;min-height: 0;
  .quest {
    //width: calc(100% - 10px);
    height: 100%;
    .title {
      font-size: 15px;
      color: #333;
    }
    .choice-list {
      margin-top: 20px;
      width: 100%;
      max-width: 560px;
      padding: 0;
      .single {
        width: 80%;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #fcd2ab;
        background-color: #fcd2ab;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        .single-letter {
          font-size: 15px;
          // font-weight: 700;
          margin-right: 5px;
        }
        .single-cte {
          font-size: 13px;
        }
        .single-img {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }

        &:hover {
          opacity: .8;
        }
      }
      .single-select {
        border-color: #d37525;
        background-color: #f8ae64;
      }
    }
  }
  .quest-img {
  margin-left: 10px;
    max-width: 40%;
    flex: 1;
    max-height: 500px;
    aspect-ratio: 833/500;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    img {
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>